import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCrmMNo0-nRajjXIZ6wsudX6c3Hadd3D4k",
  authDomain: "app-gugov3.firebaseapp.com",
  projectId: "app-gugov3",
  storageBucket: "app-gugov3.firebasestorage.app",
  messagingSenderId: "688818236455",
  appId: "1:688818236455:web:4e1745c9b8a5ed91a57202",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
